import { IDataSeriesValue } from "@/models/responses/IDataSeriesValue";

export default class DataSeriesByLabel {
  constructor(
    public label: string,
    public values: IDataSeriesValue[]
  ) { }
}
